export default "__VITE_ASSET__BuYM3mae__"